import { PhotoExports } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

export const CreatePhotoExportRequest = Simple({
  id: '4BB0D0BD-BAC2-4DA8-9EFB-E052CEDBA991',
  action: 'Create',
  object: 'Photo Export',
  page: PhotoExports,
})
